export const loadDoorSettingsState = () => {
    try {
        const serializedState = localStorage.getItem('AAECDoorState');
        if (serializedState === null ) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch ( err ) {
        return undefined;
    }
}

export const saveDoorSettingsState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('AAECDoorState', serializedState);
    } catch ( err ) {
        // Ignore write errors.
    }
}


// WEBPACK FOOTER //
// ./src/assets/scripts/service/localStorage-service.js